// Mutable object to store accessibility flags
export const a11yFlags = {
  userSkippedToContent: false,
  isFirstLoad: true,
};
